import * as types from '../constants/ActionTypes';
import {insertToast} from './index'
import api from '../../config/api.js';


export function fetchPracticeUsers(type, practiceId) {

	// eslint-disable-next-line
	return (dispatch) => {
		if(practiceId){
			api.get(`/practices/${practiceId}/${type}`)
				.then((d) => {

					if (type === 'pending_users') {
						dispatch({
							type: types.SET_APP_PRACTICE_PENDING_USERS,
							payload: d.data
						})
					} else if (type === 'parents') {
						dispatch({
							type: types.SET_APP_PRACTICE_PARENTS,
							payload: d.data
						})
					} else if (type === 'therapists') {
						dispatch({
							type: types.SET_APP_PRACTICE_THERAPISTS,
							payload: d.data
						})
					}
				})
				.catch(e => {
					if (type === 'pending_users') {
						dispatch({
							type: types.SET_APP_PRACTICE_PENDING_USERS,
							payload: []
						})
					} else if (type === 'parents') {
						dispatch({
							type: types.SET_APP_PRACTICE_PARENTS,
							payload: []
						})
					} else if (type === 'therapists') {
						dispatch({
							type: types.SET_APP_PRACTICE_THERAPISTS,
							payload: []
						})
					}
					dispatch(insertToast({
						title: 'Error',
						body: 'Error getting practice users from server'
					}))
					console.log('Error getting practice users from server', e)
				});
			}
	}
}

export function fetchPracticeAvailablePatients(practiceId) {
	// eslint-disable-next-line
	return (dispatch) => {
		return api.get(`/practices/${practiceId}/available_patients`)
			.then((d) => {
				return dispatch({
					type: types.SET_APP_PRACTICE_AVAILABLE_PATIENTS,
					payload: d.data
				})
			})
			.catch(e => {
				console.log('Error getting practice available patients from server', e)
			});
	}
}

export function practiceAddPatient(practiceId, patient) {
	return (dispatch) => {
		return api.put(`/practices/${practiceId}/patients`, patient)
			.then(d => {
				dispatch({
					type: types.INSERT_PATIENT,
					payload: patient
				})
				return dispatch({
					type: types.REMOVE_APP_PRACTICE_AVAILABLE_PATIENT,
					payload: patient._id
				})
			})
			.catch(e => {
				console.log('Error adding patient on the server', e)
			})
	}
}

export function practiceCreatePatient(practiceId, patient) {
	return (dispatch) => {
		api.put(`/patients/`, patient)
			.then(d => {
				dispatch(practiceAddPatient(practiceId, d.data))
			})
			.catch(e => {
				console.log('Error adding patient on the server', e)
			})
	}
}

export function practiceSavePatient(practiceId, patient) {
	return (dispatch) => {
		api.post(`/practices/${practiceId}/patients`, patient)
			.then(d => {
				dispatch({
					'type': types.SET_PATIENT,
					'payload': d.data
				})
			})
			.catch(e => {
				console.log('Error adding patient on the server', e)
			})
	}
}

export function practiceCreatePatientsByBulkImport(practiceId, patients) {
	return (dispatch) => {
		console.log(patients);
		return api.post(`practices/${practiceId}/patients/bulk`, patients)
			.then(d => {
				dispatch({
					type: types.SET_PATIENTS,
					payload: d.data
				});
				return d.data;
			})
			.catch(e => {
				console.log('Error adding patients on the server with bulk import', e)
			})
	}
}

export function practicArchivePatient(practiceId, patientId) {
	return (dispatch) => {
		return api.get(`/practices/${practiceId}/patients/${patientId}/archive`)
			.then(d => {
				dispatch({
					type: types.SET_PATIENTS,
					payload: [d.data]
				})
			})
			.catch(e => {
				console.log('Error archiving practice patient from server')
			});
	}
}

export function practicUnarchivePatient(practiceId, patientId) {
	return (dispatch) => {
		return api.get(`/practices/${practiceId}/patients/${patientId}/unarchive`)
			.then(d => {
				dispatch({
					type: types.SET_PATIENTS,
					payload: [d.data]
				})
			})
			.catch(e => {
				console.log('Error archiving practice patient from server')
			});
	}
}

export function practiceDeletePatient(practiceId, patientId){
	return dispatch => {
		return api.delete(`/practices/${practiceId}/patients/${patientId}`)
			.then((d) => {
				return dispatch({
					type: types.REMOVE_PATIENT,
					payload: d.data
				})
			})
			.catch(e => {
				console.log('Error deleting practice patients from server', e)
			});
	}
}

export function fetchPatientRecords(patientId) {
	return async (dispatch) => {
		// console.log('Fetch Patient records');
		return await api.get(`/patients/${patientId}/records`)
			.then(d => {
				if (d.data) {
					dispatch({
						type: types.SET_PATIENT_RECORDS,
						payload: d.data
					})

					return Promise.resolve(d.data)
				} else {
					throw new Error('No data');
				}
			})
			.catch(e => {
				console.log('Error getting patient records from server', e)
			})
	}
}

export function fetchPracticePatients(practiceId, patientId='') {
	// eslint-disable-next-line
	return (dispatch) => {
		if(practiceId) {
			return api.get(`/patients/practice/${practiceId}/${patientId}`)
			.then((d) => {
				return dispatch({
					type: types.SET_PATIENTS,
					payload: d.data
				})
			})
			.catch(e => {
				console.log('Error getting practice patients from server', e)
				return Promise.reject(new Error("Error fetching patients"))
			});
		} else{
			return dispatch({
				type: types.SET_PATIENTS,
				payload: []
			})
		}

	}
}

export function addUserToPractice(type, userId, practiceId) {
	return (dispatch) => {
		console.log('adding ' + type + ' to practice');
		return api.post(`/practices/${practiceId}/${type}`, { id: userId })
			.then(d => {
				dispatch(setUserPositions(d.data, type))
			})
			.catch(e => {
				console.log('Error getting practice parents from server', e)
			});
	}
}

export function moveUserToPracticePending(type, userId, practiceId, remove = false) {
	return (dispatch) => {
		console.log('removing ' + type + ' to practice pending');
		return api.delete(`/practices/${practiceId}/${type}/${userId}`)
			.then(d => {
				dispatch(setUserPositions(d.data, type))
			})
			.catch(e => {
				console.log('Error getting practice parents from server', e)
			});
	}
}

export function removeUserFromPractice(userId, practiceId) {
	return (dispatch) => {
		console.log('removing pending user from practice pending');
		api.delete(`/practices/${practiceId}/pending_users/${userId}`)
			.then(d => {
				dispatch({
					type: types.SET_APP_PRACTICE_PENDING_USERS,
					payload: d.data.pendingUsers
				})
			})
			.catch(e => {
				console.log('Error removing user from practice.', e)
			});
	}
}

export function setUserPositions(data, type) {
	return (dispatch) => {
		dispatch({
			type: types.SET_APP_PRACTICE_PENDING_USERS,
			payload: data.pendingUsers
		})
		if (type === 'parents') {
			dispatch({
				type: types.SET_APP_PRACTICE_PARENTS,
				payload: data[type]
			})
		} else if (type === 'therapists') {
			dispatch({
				type: types.SET_APP_PRACTICE_THERAPISTS,
				payload: data[type]
			})
		}
	}
}

export function createPractice(practice){
	return dispatch => api.post(`/practices/create`, practice)
		.then(d => {
			if(d.data){
				return dispatch({
					type: types.SET_APP_PRACTICE,
					payload: d.data
				})
			} else throw new Error('No practice data')
		})
		.catch(e => console.log(e))
}

export function savePractice(practiceId, update){
	return dispatch => api.post(`/practices/${practiceId}`, {"update":update})
		.then(d => {
			if(d.data){
				return dispatch({
					type: types.SET_APP_PRACTICE,
					payload: d.data
				})
			}else throw new Error('No practice data')
		})
		.catch(e => console.log(e))
}

export function saveLogo(img, practiceId){
	return dispatch => dispatch(savePractice(practiceId, {"logo":img}))
		.then(d => {
			dispatch({
				type: types.SET_APP_PRACTICE_FIELD,
				payload: {"key": 'logo', "val": img}
			})
			return d.data;
		})
		.catch(e => {
			console.log('Error practice logo', e)
			return e
		})
}

export function saveBackground(img, practiceId){
	return dispatch => dispatch(savePractice(practiceId, {"backgroundImg":img}))
		.then(d => {
			dispatch({
				type: types.SET_APP_PRACTICE_FIELD,
				payload: {"key": 'backgroundImg', "val": img}
			})
			return d.data;
		})
		.catch(e => {
			console.log('Error practice logo', e)
			return e
		})
}

export function updateAppPracticeField(field, value){
	return {
		type: types.SET_APP_PRACTICE_FIELD,
		payload: {"key": field, "val": value}
	}
}


export function removeUserfromPracticeRole(type, userId, practiceId) {
	return (dispatch) => {
		console.log('adding parent to practice');
		api.delete(`/practices/${practiceId}/${type}`, { id: userId })
			.then(d => {
				dispatch({
					type: types.SET_APP_PRACTICE_PENDING_USERS,
					payload: d.data.pendingUsers
				})
				if (type === 'parents') {
					dispatch({
						type: types.SET_APP_PRACTICE_PARENTS,
						payload: d.data[type]
					})
				} else if (type === 'therapists') {
					dispatch({
						type: types.SET_APP_PRACTICE_THERAPISTS,
						payload: d.data[type]
					})
				}
			})
			.catch(e => {
				console.log('Error getting practice parents from server', e)
			});
	}
}



// WEBPACK FOOTER //
// ./src/actions/practiceAdmin.js